import { ch_to_pinyin, setChineseToPinyin } from "../transcribe/ch_to_pinyin";
import { fetchJson } from "./fetchJson";

const chineseToPinyinFile = 'chineseToPinyin.json';

/** load the Chinese-to-Pinyin dictionary file */
export async function loadChineseToPinyin() {
  const entryCount = Object.getOwnPropertyNames(ch_to_pinyin).length;
  if (entryCount > 0) {
    // data already loaded
    return new Promise((resolve) => resolve('skipped'));
  }

  const p1 = fetchJson(chineseToPinyinFile, loadEvents);
  return Promise.all([p1]);
}

const loadEvents = {
  gotJson(fileName: string, json: any) {
    switch (fileName) {
      case chineseToPinyinFile:
        setChineseToPinyin(json as Record<string, string>);
        break;
    }
  },
  gotError(fileName: string, message: string) {
    console.log('error loading data', fileName, message)
  }
}
